import { memo } from 'react';
import { IconProps } from './iconType';

export const SearchIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 42 42" fill="none">
      <path
        d="M26.207 24.959L30.007 28.753L28.753 30.007L24.959 26.207C23.3664 27.4805 21.3466 28.0958 19.3146 27.9264C17.2825 27.7571 15.3924 26.816 14.0326 25.2965C12.6728 23.7769 11.9466 21.7943 12.0031 19.756C12.0596 17.7176 12.8945 15.7783 14.3364 14.3364C15.7783 12.8945 17.7176 12.0596 19.756 12.0031C21.7943 11.9466 23.7769 12.6728 25.2965 14.0326C26.816 15.3924 27.7571 17.2825 27.9264 19.3146C28.0958 21.3466 27.4805 23.3664 26.207 24.959ZM24.43 24.302C25.5693 23.1276 26.1981 21.5505 26.1795 19.9144C26.1609 18.2783 25.4963 16.7159 24.3306 15.5677C23.1649 14.4196 21.5926 13.7788 19.9564 13.785C18.3202 13.7912 16.7528 14.4439 15.5959 15.6009C14.4389 16.7578 13.7862 18.3252 13.78 19.9614C13.7738 21.5976 14.4146 23.1699 15.5627 24.3356C16.7109 25.5013 18.2733 26.1659 19.9094 26.1845C21.5455 26.2031 23.1226 25.5743 24.297 24.435L24.43 24.302Z"
        fill={color}
      />
    </svg>
  );
});

SearchIcon.displayName = 'SearchIcon';
